export const EDITOR_TUTORIAL_NAME = "editor_guided_tutorial";

// Stable DOM anchors (added in Roadmap 2 via `data-tutorial-id="..."`)
export const TUTORIAL_TARGETS = {
  CANVAS: "editor-canvas",
  EDIT_PANEL: "edit-panel",
  EDIT_PANEL_TABS: "edit-panel-tabs",
  ADD_BUTTON: "editor-add-button",
  ADD_ELEMENT_PANEL: "add-element-panel",
  NAVBAR_PAGE_CONTROLS: "navbar-page-controls",
  NAVBAR_DEVICE_PREVIEW: "navbar-device-preview",
  NAVBAR_UNDO_REDO: "navbar-undo-redo",
  NAVBAR_TOOLS: "navbar-tools",
  AI_CHAT: "ai-chat",
  AI_CHAT_ASSETS: "ai-chat-assets",
  NAVBAR_PUBLISH: "navbar-publish",
  NAVBAR_HOME_TUTORIAL: "navbar-home-tutorial",
};

// External signals used to advance certain steps (e.g. Step 1 click gate)
export const TUTORIAL_EVENTS = {
  ELEMENT_CLICKED: "editor:tutorial-element-clicked",
  ADD_BUTTON_CLICKED: "editor:tutorial-add-button-clicked",
  OPEN_ADD_ELEMENT_PANEL: "editor:tutorial-open-add-element-panel",
};

export const DEFAULT_HIGHLIGHT = {
  paddingPx: 10,
  radiusPx: 14,
};

export const COACHMARK_DEFAULT_WIDTH_PX = 360;
export const COACHMARK_GAP_PX = 12;
export const VIEWPORT_PADDING_PX = 12;

